import { css } from "styled-components";
import { responsiveMediaQueries } from "./responsiveMediaQueries";
import { isResponsiveProp } from "./ResponsiveProp";
export var buildResponsiveCss = function(rule, prop, modifierFunction) {
    var buildCssRule = function(value) {
        var _modifierFunction;
        return "".concat(rule, ": ").concat((_modifierFunction = modifierFunction === null || modifierFunction === void 0 ? void 0 : modifierFunction(value)) !== null && _modifierFunction !== void 0 ? _modifierFunction : value, ";");
    };
    return buildResponsiveMediaQueries(prop, buildCssRule);
};
export var buildResponsiveMediaQueries = function(prop, template) {
    var responsiveValues = isResponsiveProp(prop) ? prop : {
        mobileAndAbove: prop
    };
    return css([
        "",
        " ",
        " ",
        " ",
        " ",
        ""
    ], template(responsiveValues.mobileAndAbove), responsiveValues.tabletAndAbove !== undefined ? css([
        "",
        "{",
        "}"
    ], responsiveMediaQueries.tabletAndAbove, template(responsiveValues.tabletAndAbove)) : null, responsiveValues.desktopAndAbove !== undefined ? css([
        "",
        "{",
        "}"
    ], responsiveMediaQueries.desktopAndAbove, template(responsiveValues.desktopAndAbove)) : null, responsiveValues.xLargeAndAbove !== undefined ? css([
        "",
        "{",
        "}"
    ], responsiveMediaQueries.xLargeAndAbove, template(responsiveValues.xLargeAndAbove)) : null, responsiveValues.xxLargeDesktop !== undefined ? css([
        "",
        "{",
        "}"
    ], responsiveMediaQueries.xxlarge, template(responsiveValues.xxLargeDesktop)) : null);
};
